import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Dashboard, DashboardMLDetail} from "app/archivage/common/services/dashboard/dashboard.model";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {DashboardService} from "app/archivage/common/services/dashboard/dashboard.service";

@Component({
  selector: 'app-mag-detail',
  templateUrl: './mag-detail.component.html',
  styleUrls: ['./mag-detail.component.scss'],
})
export class MagDetailComponent implements OnInit, AfterViewInit {
  detailMags: MatTableDataSource<DashboardMLDetail>;
  displayedColumns: string[] = [
    'magasin',
    'batiment',
    'etage',
    'metrageTotal',
    'metrageLibre',
    'metrageOccupe',
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DashboardMLDetail[],
    public dialogRef: MatDialogRef<MagDetailComponent>,
    public dashboardSvc: DashboardService,

  ) {
    this.detailMags = new MatTableDataSource<DashboardMLDetail>(this.dashboardSvc.orderByFreeSpace(data))
  }


  ngAfterViewInit() {
    this.detailMags.paginator = this.paginator;
  }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }
}
